<div class="rich-radio-group-container"
     [attr.data-size]="size"
     [attr.data-checked]="checked"
     [attr.data-disabled]="disabled"
     [attr.data-error]="error">
  
  <umss-radio
    [value]="value"
    [name]="name"
    [checked]="checked"
    [disabled]="disabled"
    [error]="error"
    [size]="size"
    [ariaLabel]="computedAriaLabel"
    (checkedChange)="onRadioChange($event)">
  </umss-radio>
  
  <div class="rich-radio-group-content">
    <umss-label 
      [text]="label"
      [required]="required"
      size="Regular"
      weight="Medium">
    </umss-label>
    
    <p class="rich-radio-group-secondary">
      {{ secondaryText }}
    </p>
  </div>
</div>